import {
  ROUTE_COMPANY,
  ROUTE_COMPANY_WITH_EVENTS,
  ROUTE_LOCALE_COMPANY,
  ROUTE_LOCALE_COMPANY_WITH_EVENTS,
} from '@/constants/routes';
import { useLocation } from '@/hooks/useLocation';
import { getPath, isCompanyActionType } from '@/router/utils';
import { isPageSupported } from '@/utils/locale';

/**
 *
 * Navigates to the current page with the new locale but considers
 * pages that have locale support
 *
 */
export function useChangeLocale() {
  const location = useLocation();

  const changeLocale = (locale: string) => {
    if (isPageSupported(location.type, locale)) {
      let type = location.type;

      // Handle company report as a special case, as it specifically does not handle locale routes
      // in the same way as other pages.
      if (location.type === ROUTE_COMPANY && locale !== 'en') {
        type = ROUTE_LOCALE_COMPANY;
      }
      if (location.type === ROUTE_COMPANY_WITH_EVENTS && locale !== 'en') {
        type = ROUTE_LOCALE_COMPANY_WITH_EVENTS;
      }

      let newPath = getPath({
        type,
        payload: {
          ...location.payload,
          locale,
        },
      });

      // Handle company report as a special case, as it specifically does not handle locale routes
      // in the same way as other pages.
      if (isCompanyActionType(location.type) && locale === 'en') {
        newPath = newPath.replace('/en/', '/');
      }

      // Force a page load to ensure we reset any locale state.
      window.location.href = newPath;
    }
  };

  return {
    changeLocale,
  };
}
